import React from "react";
import { compose } from "redux";
import times from "lodash/times";
import classNames from "classnames";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { formatDate } from "utils/format.util";

const CalendarDaysHeader = ({ classes, startDate, numberOfDays }) => {
  return (
    <Grid container wrap="nowrap">
      {times(numberOfDays).map((day, index) => {
        const date = startDate.clone().add(day, "days");

        return (
          <Grid
            item
            container
            key={index}
            zeroMinWidth
            justifyContent="center"
            alignItems="center"
            className={classNames(classes.item, classes.calendarHeader)}
          >
            <Typography
              color="primary"
              variant="caption"
              noWrap
              className={classes.dayTitle}
            >
              {formatDate(date, "ddd")}
            </Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

const styles = theme => ({
  item: {
    boxShadow: `inset 0px 0px 1px 1px ${theme.palette.grey[100]}`,
  },
  calendarHeader: {
    padding: 2,
    height: theme.altus.row.height + 5,
  },
  dayTitle: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

export default compose(withStyles(styles), React.memo)(CalendarDaysHeader);
